module.exports = __webpack_public_path__ + "static/media/MSW_04.dcd5bd8b.jpg";